/* istanbul ignore file */
import React from 'react';
import { createRoot } from 'react-dom/client';
import initDataDog from 'common-datadog';
import Apply from './components/Apply';

import './styles/global.css';

initDataDog('apply');

const container = document.getElementById('dignifi-ui');
const root = createRoot(container);

root.render(<Apply />);
